import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const SeoJump = Memo(({ animate }) => {
	const rootRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const hlRef = useRef(null);
	const hrRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const flEl = flRef.current;
			const frEl = frRef.current;
			if (!flEl || !frEl) return;

			const flB = flEl.getBBox();
			const frB = frEl.getBBox();
			const armY = 0.42;
			const flOrigin = `${flB.x + flB.width * 0.5} ${flB.y + 1}`;
			const frOrigin = `${frB.x + frB.width * 0.5} ${frB.y + 1}`;

			const tl = gsap.timeline({ paused: true });

			tl.to(rootRef.current, { duration: 0.2, y: -20 })
				.to(flRef.current, { duration: 0.2, svgOrigin: flOrigin, rotation: 30 }, 0)
				.to(frRef.current, { duration: 0.2, svgOrigin: frOrigin, rotation: -30 }, 0)
				.to(rootRef.current, { duration: 0.2, y: 0 }, 0.2)
				.to(flRef.current, { duration: 0.2, svgOrigin: flOrigin, rotation: 0 }, 0.2)
				.to(frRef.current, { duration: 0.2, svgOrigin: frOrigin, rotation: 0 }, 0.2);

			animRef.current = tl;
		}, rootRef);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			ref={rootRef}
			className={`svg-max seoJump`}
			viewBox='0 0 166.67 232.61'>
			<polygon
				className='fill'
				points='83.34 0 0 138.5 166.67 138.5 83.34 0'
			/>

			<path
				ref={frRef}
				className={`sharpyJump-fr defaultStyle`}
				d='M91.18,129.96c.42,4.65,1.34,82.72,2.01,90.73.35,4.16,3.21,7.68,7.21,8.87,1.46.43,2.92.87,4.39,1.3'
			/>
			<path
				ref={flRef}
				className={`sharpyJump-fl defaultStyle`}
				d='M76.55,129.96c-.42,4.65-1.34,82.72-2.01,90.73-.35,4.16-3.21,7.68-7.21,8.87-1.46.43-2.92.87-4.39,1.3'
			/>
		</svg>
	);
});

export default SeoJump;
